import EnumClass, { build } from '../EnumClass';
import data, { ProductId, ProductData } from './data';
import * as Translations from './translations';

export class Product extends EnumClass<ProductId, ProductData> {
  public get getName() {
    return Translations.name[this.id];
  }
}

export const {
  list: PRODUCTS,
  getById: getProductById,
  marshaller: ProductMarshaller,
} = build<ProductId, ProductData, Product>('ProductEnum', data, Product);
